import { Box, Table, TableCell, TableContainer, styled } from '@mui/material';

export const PrimaryBorderTable = styled(Table)`
  border-collapse: separate;
  thead {
    tr {
      th {
        background-color: #f8f8ff5e;
        font-size: 14px;
        font-weight: 500;
        color: #79767d;
        border: 1px solid #efefef;
        border-left: none;
      }
    }
    tr:first-of-type th:first-of-type {
      border-top-left-radius: 10px;
      border-left: 1px solid #efefef;
    }
    tr:first-of-type th:last-of-type {
      border-top-right-radius: 10px;
    }
  }
  tbody {
    tr {
      td {
        font-size: 14px;
        font-weight: 500;
        color: #1d1b20;
        border-right: 1px solid #efefef;
        border-bottom: 1px solid #efefef;
        :first-of-type {
          border-left: 1px solid #efefef;
        }
      }
    }

    tr:last-child td:first-of-type {
      border-bottom-left-radius: 10px;
    }
    tr:last-child td:last-of-type {
      border-bottom-right-radius: 10px;
    }
  }
`;

export const MaxWidthCell = styled(TableCell)`
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
`;

export const TemptContainer = styled(TableContainer)`
  .MuiTableContainer-root {
    /* width */
    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    /* Track */
    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-corner {
      background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #999;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
`;

export const PrettyScrollbarTableWrap = styled(Box)`
  .MuiTableContainer-root {
    /* width */
    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    /* Track */
    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-corner {
      background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #999;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }

  table {
    border-collapse: separate;
  }

  th,
  td {
    padding-left: 0;
    padding-right: 0;
  }

  thead {
    tr {
      box-shadow: none !important;

      th {
        background-color: #f8f8f5;
        font-size: 14px;
        font-weight: 500;
        color: #79767d;
        border: 1px solid #efefef;
        border-left: none;
      }
    }
    tr:first-of-type th:first-of-type {
      border-top-left-radius: 10px;
      border-left: 1px solid #efefef;
    }
    tr:first-of-type th:last-of-type {
      border-top-right-radius: 10px;
    }
  }
  tbody {
    tr {
      td {
        background-color: #fff;
        font-size: 14px;
        font-weight: 500;
        color: #1d1b20;
        border-right: 1px solid #efefef;
        border-bottom: 1px solid #efefef;
        :first-of-type {
          border-left: 1px solid #efefef;
        }
      }
    }

    tr:last-child td:first-of-type {
      border-bottom-left-radius: 10px;
    }
    tr:last-child td:last-of-type {
      border-bottom-right-radius: 10px;
    }
  }
`;

export function DefaultHiphenCell({ cell }) {
  return <>{cell.getValue() || '-'}</>;
}
